// 'use client';

// import Image from 'next/image';
// import Link from 'next/link';
// import Button from '@/components/ui/Button';

// const StayConnect = () => {
//   return (
//     <>
//       {/* Join CTA Section */}
//       <section className="w-full bg-[#000000] py-12 sm:py-16 md:py-20 lg:py-[54px]">
//         <div className="w-full max-w-[1440px] mx-auto px-2 sm:px-6 lg:px-8">
//           <div className="flex flex-row justify-start items-end w-full px-4 sm:px-8 md:px-12 lg:px-[234px]">
//             {/* CTA Container */}
//             <div className="relative w-full max-w-[970px] h-[250px] sm:h-[300px] lg:h-[366px] p-1 lg:p-[4px]">
              
//               {/* Background Container */}
//               <div className="absolute inset-0 bg-[#ffffff0a] border border-[#ffffff33] rounded-[22px] mt-4 sm:mt-5 lg:mt-[20px]" />

//               {/* Main Content Stack */}
//               <div className="relative w-full h-full">
//                 {/* Gradient Overlay and Content */}
//                 <div className="absolute inset-0 mt-4 sm:mt-5 lg:mt-[20px]">
//                   <div className="relative w-full h-full">

//                     {/* Gradient Image */}
//                     <div className="absolute inset-0 w-[94%] mx-auto">
//                       <Image
//                         src="/images/gradient-overlay.webp"
//                         alt="gradient-overlay"
//                         height={300}
//                         width={300}
//                         className="object-cover"
//                         unoptimized
//                       />
//                     </div>

//                     {/* Text Content */}
//                     <div className="max-w-[1270px] absolute inset-0 flex flex-col gap-2 sm:gap-3 lg:gap-[10px] justify-start items-center px-4 sm:px-8 pt-16 sm:pt-20 lg:pt-[89px] pb-10">
//                       <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-[39px] font-open-sans font-semibold leading-8 sm:leading-10 md:leading-12 lg:leading-[55px] text-center text-white">
//                         <span className="bg-[linear-gradient(1deg,#3b00ed_0%,_#ffffff_100%)] bg-clip-text text-transparent">
//                           Stay connected for upcoming events and announcements
//                         </span>
//                         <span className="bg-[linear-gradient(1deg,#17c64f_0%,#10b981_50%,_#005529_100%)] bg-clip-text text-transparent">
//                           {' '}
//                         </span>
//                       </h2>

//                       <Link
//                         href="https://lu.ma/TheAlgorithmAlliance?k=c"
//                         target="_blank"
//                         rel="noopener noreferrer nofollow"
//                       >
//                         <Button
//                           variant="gradient"
//                           className="px-6 py-2 sm:px-8 sm:py-2.5 lg:px-[32px] lg:py-[8px] text-lg sm:text-xl lg:text-[20px] font-semibold leading-6 lg:leading-[28px] text-center rounded-[22px] "
//                         >
//                           Subscribe
//                         </Button>
//                       </Link>
//                     </div>

//                   </div>
//                 </div>
//               </div>

//             </div>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default StayConnect;

'use client';

import Link from 'next/link';
import Button from '@/components/ui/Button';

const StayConnect = () => {
  return (
    <section data-component-id="src/app/StayConnect.tsx:84:4" data-component-path="src/app/StayConnect.tsx" data-component-line="84" data-component-file="StayConnect.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22w-full%20bg-%5Blinear-gradient(360deg%2C%23060606_0%25%2C%23000000_70%25%2C_%23120049_100%25)%5D%20py-12%20sm%3Apy-16%20lg%3Apy-20%22%7D" className="w-full bg-[linear-gradient(360deg,#060606_0%,#000000_70%,_#120049_100%)] py-12 sm:py-16 lg:py-20">
      
      <div data-component-id="src/app/StayConnect.tsx:86:6" data-component-path="src/app/StayConnect.tsx" data-component-line="86" data-component-file="StayConnect.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-%5B1440px%5D%20mx-auto%20px-4%20sm%3Apx-6%20lg%3Apx-8%20flex%20justify-center%22%7D" className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 flex justify-center">
        
        {/* CTA BOX */}
        <div data-component-id="src/app/StayConnect.tsx:89:8" data-component-path="src/app/StayConnect.tsx" data-component-line="89" data-component-file="StayConnect.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20max-w-%5B970px%5D%20rounded-2xl%20border%20border-white%2F20%20bg-white%2F5%20backdrop-blur-md%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20px-6%20py-10%20sm%3Apx-10%20sm%3Apy-14%20lg%3Apx-16%20lg%3Apy-16%20text-center%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20bg-cover%20bg-center%20bg-no-repeat%20shadow-%5B0px_-8px_17px_0px_%239978FF%5D%22%7D"
          className="w-full max-w-[970px] rounded-2xl border border-white/20 bg-white/5 backdrop-blur-md
                     px-6 py-10 sm:px-10 sm:py-14 lg:px-16 lg:py-16 text-center
                     bg-cover bg-center bg-no-repeat shadow-[0px_-8px_17px_0px_#9978FF]"
          style={{
            backgroundImage: "url('/images/bg-line-demo.webp')",
            objectFit:'cover',
          }}
        >

          {/* TEXT */}
          <h2 data-component-id="src/app/StayConnect.tsx:100:10" data-component-path="src/app/StayConnect.tsx" data-component-line="100" data-component-file="StayConnect.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22uppercase%20text-2xl%20sm%3Atext-3xl%20md%3Atext-4xl%20lg%3Atext-%5B28px%5D%20font-open-sans%20font-semibold%20leading-8%20sm%3Aleading-9%20md%3Aleading-10%20lg%3Aleading-%5B39px%5D%20text-center%20bg-%5Blinear-gradient(277deg%2C%2322047d_0%25%2C_%23ffffff_100%25)%5D%20bg-clip-text%20text-transparent%20pb-10%22%2C%22textContent%22%3A%22Stay%20connected%20for%20upcoming%20events%20and%20announcements%22%7D" className="uppercase text-2xl sm:text-3xl md:text-4xl lg:text-[28px] font-open-sans font-semibold leading-8 sm:leading-9 md:leading-10 lg:leading-[39px] text-center bg-[linear-gradient(277deg,#22047d_0%,_#ffffff_100%)] bg-clip-text text-transparent pb-10">
            Stay connected for upcoming events and announcements
          </h2>

          {/* BUTTON */}
          <Link data-component-id="src/app/StayConnect.tsx:105:10" data-component-path="src/app/StayConnect.tsx" data-component-line="105" data-component-file="StayConnect.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22https%3A%2F%2Flu.ma%2FTheAlgorithmAlliance%3Fk%3Dc%22%7D"
            href="https://lu.ma/TheAlgorithmAlliance?k=c"
            target="_blank"
            rel="noopener noreferrer nofollow"
          >
            <Button data-component-id="src/app/StayConnect.tsx:110:12" data-component-path="src/app/StayConnect.tsx" data-component-line="110" data-component-file="StayConnect.tsx" data-component-name="Button" data-component-content="%7B%22elementName%22%3A%22Button%22%2C%22className%22%3A%22px-6%20py-2%20sm%3Apx-8%20sm%3Apy-3%20text-lg%20sm%3Atext-xl%20font-semibold%20rounded-full%22%2C%22textContent%22%3A%22Subscribe%22%7D"
              variant="gradient"
              className="px-6 py-2 sm:px-8 sm:py-3 text-lg sm:text-xl font-semibold rounded-full"
            >
              Subscribe
            </Button>
          </Link>

        </div>
      </div>
    </section>
  );
};

export default StayConnect;